module.exports = __webpack_public_path__ + "img/6880@2x.623c2d21.png";